import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

var _this = this;

import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { connect, ReactReduxContext } from "react-redux";
import Heading from "../heading/Heading";
import { capitalizeObjEntries } from "../../util"; // Redux

import { accountDuck } from "../../ducks/account";
import ReturnsModalForm from "../retail/returns/ReturnsModalForm";
import * as UTIL from "../../util";
import { Loading } from "../state";
import OrderCard from "./OrderCard";
import CurrentOrder from "./CurrentOrder";
import MissingCredit from "./MissingCredit";
import AccountOrderTabs from "./AccountOrderTabs";
import { FaChevronLeft } from "react-icons/fa";
var accountOperations = accountDuck.operations;

var AccountOrders = function AccountOrders(props) {
  var _props$getAccountOrde = props.getAccountOrders,
      getAccountOrders = _props$getAccountOrde === void 0 ? function () {
    return console.log("Get account orders");
  } : _props$getAccountOrde,
      isGuest = props.isGuest,
      _props$responseGuestO = props.responseGuestOrder,
      responseGuestOrder = _props$responseGuestO === void 0 ? function () {
    return "";
  } : _props$responseGuestO,
      _props$toReturn = props.toReturn,
      toReturn = _props$toReturn === void 0 ? function () {
    return "";
  } : _props$toReturn,
      _props$setShowReplace = props.setShowReplacement,
      setShowReplacement = _props$setShowReplace === void 0 ? function () {
    return "";
  } : _props$setShowReplace,
      _props$showReplacemen = props.showReplacement,
      showReplacement = _props$showReplacemen === void 0 ? function () {
    return "";
  } : _props$showReplacemen,
      token = props.token,
      _props$reOrderItems = props.reOrderItems,
      reOrderItems = _props$reOrderItems === void 0 ? function () {
    return console.log("Order Again");
  } : _props$reOrderItems,
      _props$addLineFromOrd = props.addLineFromOrder,
      addLineFromOrder = _props$addLineFromOrd === void 0 ? function () {
    return console.log("Order Again for one line item");
  } : _props$addLineFromOrd,
      _props$setReOrderSucc = props.setReOrderSuccess,
      setReOrderSuccess = _props$setReOrderSucc === void 0 ? function () {
    return "";
  } : _props$setReOrderSucc,
      reOrderSuccess = props.reOrderSuccess,
      mockOrders = props.mockOrders;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      orders = _useState2[0],
      setOrders = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      rewards = _useState4[0],
      setRewards = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isLoading = _useState6[0],
      setIsLoading = _useState6[1];

  var _useState7 = useState({}),
      _useState8 = _slicedToArray(_useState7, 2),
      fields = _useState8[0],
      setFields = _useState8[1];

  var layout = {
    background: "solid",
    padding: "medium"
  };
  var title = "Order History";
  var history = useHistory();

  var _useState9 = useState(null),
      _useState10 = _slicedToArray(_useState9, 2),
      currentOrder = _useState10[0],
      setCurrentOrder = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      showOrderDetails = _useState12[0],
      setShowOrderDetails = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      OrderAgainActionclicked = _useState14[0],
      setOrderAgainAction = _useState14[1];

  var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      showMissCreditInfo = _useState16[0],
      setShowMissCreditInfo = _useState16[1];

  var _useState17 = useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      clickedBack = _useState18[0],
      setClickedBack = _useState18[1];

  useEffect(function () {
    if (mockOrders && mockOrders === "true") {
      getAccountOrders().then(function (response) {
        setOrders(response.data.orders);
        setFields(response.data.fields);
        setIsLoading(false);
      });
    } else {
      var _isLoading = props.isLoading,
          _orders = props.orders,
          _fields = props.fields;

      if (_isLoading) {
        setIsLoading(_isLoading);
      } else if (_orders) {
        setIsLoading(false);

        if (_orders.length >= 0) {
          setOrders(_orders);
        }
      }

      if (_fields) {
        setFields(_fields);
      }
    }
  }, [props.orders, props.isLoading, mockOrders]);

  if (UTIL.mobileAppUtil.isMobileApp()) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, !showOrderDetails || !showMissCreditInfo ? /*#__PURE__*/React.createElement(AccountOrderTabs, {
      orders: orders,
      rewards: rewards,
      setShowOrderDetails: setShowOrderDetails,
      setCurrentOrder: setCurrentOrder,
      setShowMissCreditInfo: setShowMissCreditInfo,
      isLoading: isLoading
    }) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "cb-account-card__nav-container"
    }, !isGuest && !showMissCreditInfo && /*#__PURE__*/React.createElement("a", {
      href: "#",
      className: "cb-account-card__back",
      onClick: function onClick(e) {
        e.preventDefault();
        setShowOrderDetails(false);
        setClickedBack(true);
      }
    }, /*#__PURE__*/React.createElement(FaChevronLeft, null)), !showMissCreditInfo && /*#__PURE__*/React.createElement("span", {
      className: "cb-account-card__nav-header"
    }, "Order Details")), !showMissCreditInfo && showOrderDetails ? /*#__PURE__*/React.createElement(CurrentOrder, _extends({
      order: currentOrder,
      isGuest: isGuest,
      returnAction: function returnAction(item) {
        setShowReplacement(true);
        toReturn(item);
      },
      topAction: function topAction(orderId, lineId) {
        addLineFromOrder(orderId, lineId);
        setOrderAgainAction(true);
      },
      fields: fields
    }, props)) : /*#__PURE__*/React.createElement(MissingCredit, _extends({}, props, {
      setShowMissCreditInfo: setShowMissCreditInfo
    }))));
  }

  return /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (context) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, !showOrderDetails && !showMissCreditInfo ? /*#__PURE__*/React.createElement(AccountOrderTabs, {
      orders: orders,
      rewards: rewards,
      setShowOrderDetails: setShowOrderDetails,
      setCurrentOrder: setCurrentOrder,
      setShowMissCreditInfo: setShowMissCreditInfo,
      isLoading: isLoading
    }) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "cb-account-card__nav-container"
    }, !isGuest && !showMissCreditInfo && /*#__PURE__*/React.createElement("a", {
      href: "#",
      className: "cb-account-card__back",
      onClick: function onClick(e) {
        e.preventDefault();
        setShowOrderDetails(false);
        setClickedBack(true);
      }
    }, /*#__PURE__*/React.createElement(FaChevronLeft, null)), !showMissCreditInfo && /*#__PURE__*/React.createElement("span", {
      className: "cb-account-card__nav-header"
    }, "Order Details")), !showMissCreditInfo && showOrderDetails ? /*#__PURE__*/React.createElement(CurrentOrder, {
      order: currentOrder,
      isGuest: isGuest,
      returnAction: function returnAction(item) {
        setShowReplacement(true);
        toReturn(item);
      },
      topAction: function topAction(orderId, lineId) {
        addLineFromOrder(orderId, lineId);
        setOrderAgainAction(true);
      },
      fields: fields,
      mockOrders: mockOrders
    }) : /*#__PURE__*/React.createElement(MissingCredit, {
      setShowMissCreditInfo: setShowMissCreditInfo,
      fields: (fields === null || fields === void 0 ? void 0 : fields.MissingCredit) && (fields === null || fields === void 0 ? void 0 : fields.MissingCredit.length) >= 1 ? fields.MissingCredit[0].fields : {}
    })));
  }.bind(_this));
};

var mapStateToProps = function mapStateToProps(state) {
  var _state$account, _state$account2, _state$account3, _state$account4, _state$account5;

  return {
    orders: (_state$account = state.account) === null || _state$account === void 0 ? void 0 : _state$account.orders,
    isLoading: (_state$account2 = state.account) === null || _state$account2 === void 0 ? void 0 : _state$account2.isLoading,
    showReplacement: (_state$account3 = state.account) === null || _state$account3 === void 0 ? void 0 : _state$account3.showReplacement,
    isError: state.error.isError,
    err: state.error.err,
    token: (_state$account4 = state.account) === null || _state$account4 === void 0 ? void 0 : _state$account4.aadResponse,
    reOrderSuccess: (_state$account5 = state.account) === null || _state$account5 === void 0 ? void 0 : _state$account5.reOrderSuccess
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getAccountOrders: function getAccountOrders() {
      return dispatch(accountOperations.getAccountOrders());
    },
    responseGuestOrder: function responseGuestOrder() {
      return dispatch(accountOperations.responseGuestOrder({
        orders: []
      }));
    },
    toReturn: function toReturn(item) {
      return dispatch(accountOperations.toReturn(item));
    },
    setShowReplacement: function setShowReplacement(el) {
      return dispatch(accountOperations.setShowReplacement(el));
    },
    reOrderItems: function reOrderItems(orderId) {
      return dispatch(accountOperations.reOrderItems(orderId));
    },
    setReOrderSuccess: function setReOrderSuccess(success) {
      return dispatch(accountOperations.responseReOrder(success));
    },
    addLineFromOrder: function addLineFromOrder(orderId, lineId) {
      return dispatch(accountOperations.addLineFromOrder(orderId, lineId));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountOrders);